// Manifest shopu jipos.cz (S2 #398, plán docs/ops/plan-cutover-sk.md §S2).
//
// Jediné místo pro klientské konstanty šablony, které se liší mezi shopy.
// Moduly ho čtou přes `src/config/shop.js` (ne přímo tenhle soubor): v Node
// (devchecky, unit testy) ten re-exportuje CZ manifest, SK build ho esbuild
// pluginem v build.mjs přesměruje na bs.config.sk.mjs. Tvar hlídá
// tools/lib/bs-config.mjs — neznámý nebo chybějící klíč = build fail.
//
// UI texty sem nepatří (locale vrstva, S3), jen data a identifikátory. Data
// shopu v jeho jazyce (role lidí v týmu, citace recenzí) sem patří — nepřekládají
// se, každý shop má svoje.

export default {
  shop: {
    code: 'cs',
    // název shopu: copyright, alt loga, textový fallback loga
    name: 'Jipos.cz',
    // značka bez domény: autor odpovědí v diskuzi za obchod (productDetail.js)
    brand: 'Jipos',
    // doména bez www: zobrazená URL ve výsledcích hledání, UTM zdroj odkazů ven
    domain: 'jipos.cz',
    origin: 'https://www.jipos.cz',
    language: 'cs',
    // země shopu (ISO 3166-1): vlajka a kód v přepínači CZ ↔ SK (countrySwitch.js)
    country: 'CZ',
    // státní svátky a ostatní svátky ČR (zákon 245/2000 Sb.): konec lhůty na vrácení na ně
    // připadající se posouvá na pracovní den (§ 607 OZ, stránka Stav objednávky)
    holidays: ['1-1', '5-1', '5-8', '7-5', '7-6', '9-28', '10-28', '11-17', '12-24', '12-25', '12-26'],
    currency: 'CZK',
    // symbol a strana jako shoptet.config.currencySymbol/-Left („2 000 Kč");
    // money.js je bere z dataLayeru, tohle je záloha
    currencySymbol: 'Kč',
    currencySymbolLeft: false,
    timeZone: 'Europe/Prague',
  },

  // projectId instancí Shoptetu. `dev` = testovací instance (null = shop ji nemá);
  // `assetsHost` = hostname v CDN cestě `cdn.myshoptet.com/usr/<host>/`, na který
  // padají offline fixtures (file://) a fallback našeho buildu (instanceUrl.js).
  instances: {
    live: 585781,
    dev: 797093,
    assetsHost: '797093.myshoptet.com',
  },

  // vlastní vyhledávání (searchConfig.js): projectId → tenant v search/data/tenants.json
  search: {
    api: 'https://hledani.jipos.cz',
    tenants: {
      585781: 'jipos-cz',
      797093: 'jipos-dev',
    },
    // ceníky, jejichž cenu index nese (`price_vat_pl<id>`, API `pl`): 1 = hlavní
    // (maloobchod) první, za ním VO. Musí sedět se search/indexer/schema.mjs
    // VO_PRICELIST_IDS (hlídá tools/unit/search-config.test.mjs).
    priceLists: [1, 13, 16, 19],
  },

  // Ceník dopravy a plateb = ZRCADLO tarifu `hmotnostni` v tools/admin/doprava-cenik.mjs
  // (od 2026-09-05 pásma po 10 kg; nad 30 kg jen Fofr 299 od 2026-09-10). Mění
  // se VŽDY spolu s ním — drift hlídá tools/devcheck/shipping-page.mjs, které
  // tarif ze skriptu načítá. Shoptet pásmo ani ceny cizích pásem nevydává,
  // proto je šablona nese sama (shippingModel.js, škála kroku 2, /doprava-platba/).
  shipping: {
    // horní hranice pásem v kg; řádek ceníku je „od včetně / do exkluzivně"
    // (přesně 10,00 kg = pásmo 10–20)
    weightBands: [10, 20, 30],
    // doprava zdarma nad `freeShipFrom` Kč platí JEN v prvním pásmu a jen na
    // výdejní místo; `freeShipFrom` = záloha za dataLayer `freeShippingFrom`,
    // který u košíku nad limitem zdarma chybí (živá hodnota má přednost)
    freeShipMaxKg: 10,
    freeShipFrom: 2000,
    // ceny per pásmo: výdejní místo / adresa
    bandPrices: [
      { box: 69, addr: 119 },
      { box: 99, addr: 139 },
      { box: 149, addr: 199 },
    ],
    // „PPL – Nadrozměrné zásilky" per pásmo (pásma adresy s podlahou 149)
    oversizeBandPrices: [149, 149, 199],
    // „Fofr – Nadměrné balíky" nad posledním pásmem (jediná metoda)
    overPrice: 299,
    // nad posledním pásmem jede jen „Fofr – Nadměrné balíky"
    overFromKg: 30,
    // limity výdejních míst = limity DOPRAVCŮ, zkracují poslední pásmo (GLS tím
    // pásmo 20–30 nemá vůbec, PPL ho veze jen do 28 kg)
    boxLimits: { GLS: 20, PPL: 28 },
    // doprava na adresu jede na CZ do konce pásem (tam přebírá Fofr) — vlastní
    // strop dopravce tu žádná metoda nemá
    addrLimits: {},
    // Dobírka — Shoptet ceny plateb v API nevydává; ověřeno z rekapitulace kroku 3
    // na dev (fixture dev/checkout-2.html „Dobírkou 40 Kč").
    codFee: 40,
    // Uzávěrka expedice skladu po dnech v týdnu (1 = pondělí … 5 = pátek), hodiny
    // desetinně: objednávka do uzávěrky pracovního dne odchází týž den
    // (dispatchEta.js; z ní karta výpisu, osa detailu, košík, pokladna, okna
    // závozů i stránka Doprava a platba). Pátek 14:30 = zadání klienta 2026-10-13
    // (páteční objednávka GLS ze 14:23 už neodešla). Nativní Shoptet zná jen jednu
    // uzávěrku pro všechny dny (`/admin/zobrazeni-zbozi/` „15:00"), pátek proto
    // počítá šablona a nativní termín po páteční uzávěrce přebíjí deliveryTimeline.
    dispatchCutoff: { 1: 15, 2: 15, 3: 15, 4: 15, 5: 14.5 },
    // Zvláštní závozy dopravců mimo rytmus skladu (deliveryTimeline.js
    // FAST_RULES): sobotní doručení GLS a nedělní svoz PPL, obojí ze zadání
    // klienta — svážíme z Bíliny.
    fastRules: ['sat', 'sun'],
    // termín doručení je jedno pevné datum (nativní den Shoptetu, jinak další
    // pracovní den po expedici); rozmezí zapíná jen SK
    deliverySpanDays: 0,
    // termín doručení začíná další pracovní den po expedici
    deliveryStartDays: 1,
    // osobní odběr na prodejně v Bílině
    pickup: true,
    // Akce PPL na výdejní místo do 10 kg za 19 Kč, 12.–25. 10. 2026 (#322,
    // rozhodnutí Tomáše 24. 9.: jen PPL, práh dopravy zdarma trvá, jen CZ).
    // Overlay nad `bandPrices` — ceník v adminu přepíná Tomáš tarifem
    // `akce-ppl-19` (tools/admin/doprava-tarify.mjs) 12. 10. ráno a vrací 26. 10.;
    // šablona mluví o akci jen v okně A se zapnutým přepínačem `pplBox19`.
    // Okno je pojistka konce: 25. 10. 23:59:59 zhasne i bez commitu.
    promo: [
      {
        id: 'ppl-19-2026-10',
        feature: 'pplBox19',
        carrier: 'PPL',
        price: 19,
        maxKg: 10,
        from: '2026-10-12T00:00',
        until: '2026-10-25T23:59:59',
        // karta „Doprava od 69 Kč" po dobu akce na 2. místě; `media` = vizuál akce
        // (2026-10-07, ops/hero/2026-10-ppl19/zaznam.md): balík s logem Jipos před
        // boxem PPL, still z Codexu s přesným logem Jipos, video = přiblížení stillu
        hero: {
          video: 'hf_20260712_123317_88fdd4c7-3970-4326-a492-ef7c512d4436',
          position: 1,
          badge: 'AKCE DO 25. 10.',
          title: 'PPL za 19 Kč',
          desc: 'Doprava na výdejní místo PPL za 19 Kč u zásilek do 10 kg. Nad 2 000 Kč zdarma.',
          cta: 'Více o dopravě',
          // tmavá dlažba pod textem → bílý text se závojem zdola (karta mimo akci má tmavý)
          media: {
            video: 'codex_20261007_ppl19_c3',
            posterSrc: 'codex_20261007_ppl19_c3.png',
            tone: 'dark',
            overlay: 'bottom',
            ink: false,
          },
        },
      },
      // Akce PPL na výdejní místo za 49 Kč u zásilek do 2 kg, 1.–30. 11. 2026
      // (jipos-43, Tomáš 28. 10.: práh 2 kg z dat ops/sweeps/2026-10-28-ppl-49-prah/,
      // ohlásit jako PPL 19 na všech plochách, konec koncem listopadu). Ceník
      // přepíná plánovač tarifem `akce-ppl-49` 31. 10. 23:00 a vrací 1. 12. 00:10.
      // `maxKg` 2 leží uvnitř prvního pásma: 2–10 kg stojí dál 69, plochy proto
      // píšou rozsah do 2 kg a výdejní místo „od 49 Kč". Vizuál karty = vizuál
      // PPL 19 (balík Jipos před boxem PPL, cenu nenese).
      {
        id: 'ppl-49-2026-11',
        feature: 'pplBox49',
        carrier: 'PPL',
        price: 49,
        maxKg: 2,
        from: '2026-11-01T00:00',
        until: '2026-11-30T23:59:59',
        hero: {
          video: 'hf_20260712_123317_88fdd4c7-3970-4326-a492-ef7c512d4436',
          position: 1,
          badge: 'AKCE DO 30. 11.',
          title: 'PPL za 49 Kč',
          desc: 'Doprava na výdejní místo PPL za 49 Kč u zásilek do 2 kg. Nad 2 000 Kč zdarma.',
          cta: 'Více o dopravě',
          media: {
            video: 'codex_20261007_ppl19_c3',
            posterSrc: 'codex_20261007_ppl19_c3.png',
            tone: 'dark',
            overlay: 'bottom',
            ink: false,
          },
        },
      },
    ],
  },

  // Velkoobchodní úrovně z /b2b/ podle `priceListId` Shoptetu: název a sleva
  // úrovně z pravidla ceníku (reporting-saas F34, `shared.pim_pricelist_rule`).
  // Procento je POPIS ÚROVNĚ pro Moje slevy — cena produktu ani úspora z něj
  // nikdy nevznikají (skutečná sleva bývá kvůli podlaze marže nižší).
  wholesale: {
    pricelists: {
      13: { name: 'Jipos Standard', discountPct: 10 },
      16: { name: 'Jipos Plus', discountPct: 15 },
      19: { name: 'Jipos Premium', discountPct: 20 },
    },
  },

  // Kontakt a provoz (headerTools.js CONTACT, jediný zdroj pro celý web).
  // ⚠️ DVĚ RŮZNÉ DOBY (zadání klienta 2026-09-15): `openHours` = PRODEJNA
  // (výdejní místo, osobní odběr), `supportHours` = ZÁKAZNICKÁ PODPORA e-shopu.
  // Kontaktní bloky (hlavička, patička, drawer, 404, poradce na detailu, klientská
  // sekce, hlavička pokladny) mluví o podpoře; o prodejně jen místa o vyzvednutí
  // a stránky prodejny/kontaktu. Rozpis per den v týdnu (0 = neděle), hodiny
  // desetinně, chybějící den = zavřeno.
  contact: {
    email: 'info@jipos.cz',
    phone: '+420 417 823 111',
    // Přepínač telefonů na celém webu (headerTools.phonesOn). Od 2026-09-10
    // VYPNUTO (zadání Tomáše před migrací): telefony se nikde nekreslí. Zpět =
    // `true`; dokud je `false`, admin blok `#bs-config[data-bs-phones]` nic
    // nezapne. Harnessy čtou tuhle hodnotu přes tools/lib/phones.mjs.
    showPhones: false,
    billingEmail: 'fakturace@jipos.cz',
    // ⚠️ Prodejna má otevřeno i o VÍKENDU: sobota 8:30–13:00 (potvrdil Tomáš
    // 2026-08-31) a od 2026-09-02 i NEDĚLE 8:30–13:00 (zadání Tomáše — stejný
    // čas jako sobota, platí pro prodejnu i výdejní místo). Stránky /kontakt/
    // a /prodejna-naradi/ nesou tutéž dobu z administrace (`storePage.js` ji
    // parsuje z textu „Po–Pá 07:30–17:00 • So–Ne 08:30–13:00"); kdo mění hodiny,
    // mění je tady i tam. Podle tohohle rozpisu se počítá stav prodejny
    // a nejbližší termín vyzvednutí (`shippingModel.js`).
    openHours: {
      0: { from: 8.5, to: 13 },
      1: { from: 7.5, to: 17 },
      2: { from: 7.5, to: 17 },
      3: { from: 7.5, to: 17 },
      4: { from: 7.5, to: 17 },
      5: { from: 7.5, to: 17 },
      6: { from: 8.5, to: 13 },
    },
    // Po–Čt 8:00–15:00, Pá 7:30–14:30, o víkendu nepracuje (zadání klienta
    // 2026-09-15, pátek podle pracovní doby schránky SupportBoxu 2026-09-16,
    // srovnáno 2026-10-11). Zelená tečka u telefonu a stav karty podpory
    // v draweru jedou podle tohohle, e-maily objednávek taky (patička).
    supportHours: {
      1: { from: 8, to: 15 },
      2: { from: 8, to: 15 },
      3: { from: 8, to: 15 },
      4: { from: 8, to: 15 },
      5: { from: 7.5, to: 14.5 },
    },
    // Poradna na detailu produktu (productDetail.js). Jména jen křestní (zadání
    // Tomáše 2026-09-10, platí na celém webu); kontakt = společná schránka
    // `email` (osobní adresy se na webu neuvádějí, klient 2026-09-15).
    expert: { name: 'Veronika', role: 'Vedoucí e-shopu', photo: 'poradce-veronika.jpg' },
    // Sekce Tým na /kontakt/ (contactPage.js, handover §1.4); `slot` = casting
    // fotky v teamPhoto.js, `icon` = náhrada bez fotky. Role podle klienta
    // 2026-09-15, všechny karty vedou na `email`.
    team: [
      { name: 'Veronika', role: 'Vedoucí e-shopu', slot: 'teamVeronika', icon: 'user' },
      { name: 'Andrea', role: 'Zástupce jednatele', slot: 'teamAndrea', icon: 'user' },
      { name: 'Nikola', role: 'Vedoucí zákaznické podpory', slot: 'teamSupport', icon: 'headset' },
    ],
  },

  // Prodejna = výdejní místo osobního odběru (shippingModel.js, patička).
  // `address` = plná adresa s PSČ, `place` = „město, ulice" (ceník a řádek
  // odběru na /doprava-platba/), `mapUrl` = odkaz do map (odběr, patička,
  // řádek Google v hodnocení — Google nemá stabilní place-URL bez CID).
  store: {
    address: 'Teplická 906, 418 01 Bílina',
    place: 'Bílina, Teplická 906',
    mapUrl: 'https://www.google.com/maps/search/?api=1&query=Jipos.cz+Teplick%C3%A1+906+B%C3%ADlina',
  },

  // Obsah homepage (homepage.js, 03-homepage.md §1, §9, §10). Videa i postery
  // hera jsou nahrané v adminu (assets/media/_manifest.json), cíle karet se
  // shodují s nativními bannery. CTA produktových karet je „Koupit" (průchod na
  // detail) — banner nemá ID produktu a košík smí obsluhovat jen
  // shoptet.cartShared.addToCart z detailu / karty výpisu. `price` / `priceOld`
  // jsou čísla v měně shopu (formát dodá money()), ručně podle stránky ostré.
  homepage: {
    heroDefault: 2, // karta, která hraje bez interakce (Křovinořez BT7010)
    hero: [
      {
        // Vizuál E kampaně Říjnový výprodej (2026-10-07, ops/hero/2026-10-vyprodej/zaznam.md):
        // still z Codexu podle fotek sady BX187, video = jemné přiblížení stillu
        // (Codex videa neumí). Karta zůstává kartou Slevoakce, po dobu kampaně nese
        // text deštníku (campaigns[].hero); přednačtený poster hlavičky jde z téhle karty.
        video: 'codex_20261007_vyprodej_e',
        posterSrc: 'codex_20261007_vyprodej_e.png',
        tone: 'brand',
        overlay: 'none',
        ink: false,
        badge: null,
        title: 'SLEVOAKCE právě běží!',
        desc: 'Slevy až −40 % na nářadí i zahradní techniku, jen do vyprodání zásob.',
        price: null,
        priceOld: null,
        note: null,
        cta: 'Zobrazit slevy',
        ctaTone: 'white',
        page: 'sale',
        href: null,
      },
      {
        // Podzim/zima 2026-09-21 (ops/hero/2026-09-21-navrhy/zaznam.md): scéna podle
        // snímků reelu klienta (kamna, lžíce granulí, modrý plamen), ne domněnka modelu.
        video: 'hf_20260921_140151_7c7bd67f-a51a-457c-b42c-23b208bd8e17',
        posterSrc: 'hf_20260921_140026_66aed9c3-2eae-44e8-81df-09045437a91c.png',
        tone: 'light',
        overlay: 'bottom',
        ink: false,
        badge: 'BESTSELLER',
        title: 'Čistič komína SADPAL 1 kg',
        desc: null,
        price: 149,
        priceOld: null,
        note: 'pro kotle, kamna i krby',
        cta: 'Koupit',
        ctaTone: null,
        page: null,
        href: '/cistic-komina-a-vsech-casti-kotlu-sadpal-1kg/',
      },
      {
        // Mockup psal BT7010, produkt se na shopu jmenuje RS7000 (slug zůstal starý).
        // Sleva jako u ostatních produktových karet: přeškrtnutá cena, ne věta
        // v popisu (review Tomáše 2026-09-21). Cena ze stránky ostré 2026-09-21.
        // overlay bottom: přeškrtnutá cena potřebuje tmavý spodek
        video: 'hf_20260712_131252_734e3d77-55fe-401b-b9ec-16bace86000b',
        posterSrc: 'hf_20260712_124215_8f6b905c-b2cb-45d6-bd04-1c70d74b082a.png',
        tone: 'brand',
        overlay: 'bottom',
        ink: false,
        badge: 'AKCE TÝDNE',
        title: 'Benzínový křovinořez 3,9\u00A0kW',
        desc: null,
        price: 1699,
        priceOld: 2590,
        note: null,
        cta: 'Koupit',
        ctaTone: null,
        page: null,
        href: '/benzinovy-krovinorez-3-91kw-bt7010-bulltech-extra-vybava-ondragon/',
      },
      {
        // Video přegenerované 2026-08-31 (zadání Tomáše): v původním klipu se
        // uprostřed záběru „z ničeho" objevovalo stropní světlo. Nový klip jede
        // z téhož posteru (omni_reference), strop i regály drží statické.
        video: 'hf_20260831_102635_e7efab86-2f7f-48fa-bb7a-93142e9c0c7b',
        posterSrc: 'hf_20260712_123906_8345f9e7-5b04-4fa6-bf8c-5b4b83e5aef7.png',
        tone: 'dark',
        overlay: 'flat-2',
        ink: false,
        badge: null,
        title: 'Navštivte prodejnu Jipos',
        desc: 'Teplická 906, Bílina. Nářadí si osaháte naživo, poradíme s výběrem.',
        price: null,
        priceOld: null,
        note: null,
        cta: 'O prodejně',
        ctaTone: null,
        page: 'store',
        href: null,
      },
      {
        // ink: text je tmavý (světlé video, karta 7 v mockupu)
        video: 'hf_20260712_123317_88fdd4c7-3970-4326-a492-ef7c512d4436',
        posterSrc: 'hf_20260712_123202_1a2dd80b-3935-4f0e-b4c8-10217a2145a8.png',
        tone: 'light',
        overlay: 'none',
        ink: true,
        badge: null,
        title: 'Doprava od 69 Kč',
        desc: 'Nakupte dnes, zítra sekáte. Doručujeme PPL po celé ČR.',
        price: null,
        priceOld: null,
        note: null,
        cta: 'Více o dopravě',
        ctaTone: null,
        page: 'shipping',
        href: null,
      },
    ],
    // Rady a návody (§9): reálné články shopu (URL, titulky ověřené proti
    // /rubriky/rady-a-tipy/), fotky karet generované lifestyle záběry art-*.jpg
    // (zadání 2026-08-31); meta = rubrika, dobu čtení Shoptet nenese
    articles: [
      {
        href: '/na-jakych-faktorech-zavisi-vyber-krovinorezu/',
        title: 'Na jakých faktorech závisí výběr křovinořezu?',
        image: 'art-krovinorez.jpg',
        meta: 'Rady a tipy',
      },
      {
        href: '/motorove-benzinove-retezove-pily-a-elektricke-retezove-pily---jaky-je-mezi-nimi-rozdil/',
        title: 'Motorové benzínové a elektrické řetězové pily – jaký je mezi nimi rozdíl?',
        image: 'art-retezova-pila.jpg',
        meta: 'Rady a tipy',
      },
      {
        href: '/sekacka-na-travu---benzinova--elektricka-nebo-aku/',
        title: 'Sekačka na trávu – benzínová, elektrická nebo AKU?',
        image: 'art-sekacka.jpg',
        meta: 'Rady a tipy',
      },
      {
        href: '/podzimni-uklid-zahrady-s-ochrannymi-pomucky/',
        title: 'Podzimní úklid zahrady s ochrannými pomůckami',
        image: 'art-podzimni-uklid.jpg',
        meta: 'Rady a tipy',
      },
    ],
    aboutBadge: 'Teplická 906, Bílina',
  },

  // Hodnocení obchodu (reviews.js: sekce v patičce, trust karta /login/
  // a /registrace/, dlaždice v pokladně). Recenze U2 (mock schválený Tomášem
  // 6. 10. 2026): manifest určuje, KTERÉ platformy se ukazují, v jakém pořadí,
  // s jakým logem a odkazem, a nese ZÁLOŽNÍ čísla. Zboží.cz, Firmy.cz a Jipos.cz
  // přepisuje denně `/reviews/summary` (job recenzí na s1, U1); Heureka (ze s1
  // 403 i v Chromiu) a Google (Places odloženo) v API nejsou → čísla jen tady,
  // ručně. Odkazy vedou na PROFILY shopu (nové okno, zadání Tomáše 2026-08-31;
  // Heureka slug jipos-cz, Zboží id 38074, Firmy id 13972137).
  reviews: {
    // dlaždice „Ověřený obchod" v košíku a pokladně (checkoutPage.js, text
    // z řádku Heureky níž: „Na Heurece nás doporučuje 96 % zákazníků")
    checkoutTile: true,
    // počet zákazníků (údaj klienta, ne hodnocení; nejde spočítat z platforem)
    customers: 30000,
    // „Jak recenze ověřujeme" (§ 5a odst. 5 ZOS) = sekce stránky Hodnocení obchodu
    // (`pages.ratings`) s touhle kotvou (ratingsPage.js, reviewsVerify.js). Vede na
    // ni karta recenzí na detailu, patička i e-mail „Prosba o recenzi" (recenze U5),
    // stará stránka /jak-recenze-overujeme/ přesměrovává 301 sem (zadání Tomáše
    // 7. 10. 2026). Kotva je adresa z odeslaných e-mailů: neměnit. null = sekci
    // shop nemá a odkazy na ni se nekreslí.
    verifyAnchor: 'jak-recenze-overujeme',
    // Řádek = NATIVNÍ metrika platformy: `metric: 'pct'` = procento spokojených
    // či doporučujících zákazníků (0–100, Heureka za 90 dní, Zboží.cz za 12 měsíců,
    // počet je celkový), `'stars'` = průměr hvězd 0–5. Na hvězdy se procenta
    // převádějí jen v souhrnu (lineárně, 96 % = 4,8) a souhrn to říká.
    // `pool` = platforma přebírá hodnocení jiné (Firmy.cz ze Zboží.cz): řádek se
    // ukazuje, do součtu nejde. `own` = hodnocení napsaná přímo na webu shopu
    // (jen nativní formulář, importy Heureky počítá řádek Heureky); odkaz vede
    // na `pages.ratings`, proto `href: null`. Čísla k 6. 10. 2026 (sonda
    // ops/sweeps/2026-10-06-recenze/, API summary téhož dne).
    platforms: [
      // `logo` = id symbolu ve spritu logos.svg; `name` = aria-label a text za logem
      { key: 'heureka', logo: 'heureka', name: 'Heureka', metric: 'pct', value: 96, count: 6930, href: 'https://obchody.heureka.cz/jipos-cz/recenze/', pool: null, own: false },
      { key: 'zbozi', logo: 'zbozi', name: 'Zboží.cz', metric: 'pct', value: 93, count: 11006, href: 'https://www.zbozi.cz/obchod/38074/', pool: null, own: false },
      // Google nemá stabilní place-URL bez CID → odkaz do map (store.mapUrl)
      { key: 'google', logo: 'google', name: 'Google', metric: 'stars', value: 4.7, count: 2946, href: 'https://www.google.com/maps/search/?api=1&query=Jipos.cz+Teplick%C3%A1+906+B%C3%ADlina', pool: null, own: false },
      { key: 'firmy', logo: 'firmy', name: 'Firmy.cz', metric: 'stars', value: 4.5, count: 10988, href: 'https://www.firmy.cz/detail/13972137-jipos-cz-bilina-teplicke-predmesti.html', pool: 'zbozi', own: false },
      { key: 'jipos', logo: 'jipos', name: 'Jipos.cz', metric: 'stars', value: 4.88, count: 368, href: null, pool: null, own: true },
    ],
    // Záložní citace (offline fixtures, výpadek API): doslovné recenze ze stránky
    // /hodnoceni-obchodu/ včetně překlepů (zákaznická citace se needituje), tvar
    // jako položka `/reviews/context` (search/indexer/reviews.mjs `toQuote`).
    quotes: [
      { rating: 5, date: '2026-05-30', source: 'heureka', text: 'Rychlost vyřízení objednávky. V sobotu objednáno a následující pondělí dodáno.' },
      { rating: 5, date: '2026-05-30', source: 'heureka', text: 'Úžasná paní pokladní...odpověděla perfektně na všechny otázky ... poradila i s opravou...' },
      { rating: 5, date: '2026-05-26', source: 'heureka', text: 'Jeden den jsem objednala druhý den jsem zboží měla.Neporušené.' },
    ],
    // Odznaky třetích stran (zadání Tomáše 2026-09-09) jako statický obrázek
    // s odkazem, ne embed skript (Retino embed zakládá cookie a tracking pixel);
    // `w`/`h` = poměr stran slotu. Retino stojí pod řadou ostatních.
    badges: [
      {
        key: 'heureka',
        // widget typ 12 shopu 12452 („Ověřeno zákazníky" s % a počtem recenzí za 90 dní)
        src: 'https://im9.cz/cb/12452-12.png',
        href: 'https://obchody.heureka.cz/jipos-cz/recenze/',
        alt: 'Heureka.cz – ověřené hodnocení obchodu Jipos.cz',
        w: 130,
        h: 160,
      },
      {
        key: 'firmy',
        src: 'https://www.firmy.cz/top-firma/2025.svg',
        href: 'https://www.firmy.cz/detail/13972137-jipos-cz-bilina-teplicke-predmesti.html',
        alt: 'Firmy.cz – TOP firma 2025',
        w: 138,
        h: 120,
      },
      {
        key: 'retino',
        src: 'https://cdn.retino.com/media/0e86e545-f843-4d17-8fe6-1e2f8abe4e68/badges/cs/current/icon.png',
        href: 'https://app.retino.com/cs/client/0e86e545-f843-4d17-8fe6-1e2f8abe4e68/badge/report/',
        alt: 'Retino – bezproblémové reklamace, 95 % zákazníků spokojených s vyřízením',
        w: 363,
        h: 134,
      },
    ],
  },

  // Wordmarky značek: `slug` = detail značky pod `pages.brands`.
  brands: {
    // slug vlastní značky „Jipos Tools" (chip v liště menu, megaMenu.js)
    own: 'jipos',
    // pás „Značky u nás" v patičce (siteFooter.js). Design má BULLTECH · ONDRAGON
    // · Boxer · POWERMAT · JIPOS, jenže „Boxer" značka shopu není (jen názvy
    // produktů) → nahrazeno reálnou GEKO; finální výčet = otevřený bod 2 handoffu.
    footer: [
      { label: 'BULLTECH', slug: 'bulltech' },
      { label: 'ONDRAGON', slug: 'ondragon' },
      { label: 'POWERMAT', slug: 'powermat' },
      { label: 'GEKO', slug: 'geko' },
      { label: 'JIPOS', slug: 'jipos' },
    ],
    // pás značek na stránce prodejny (storePage.js), ověřeno proti /znacka/ na
    // dev instanci 2026-07-30
    store: [
      { label: 'BULLTECH', slug: 'bulltech' },
      { label: 'ONDRAGON', slug: 'ondragon' },
      { label: 'BOXER', slug: 'boxer' },
      { label: 'POWERMAT', slug: 'powermat' },
      { label: 'BASS', slug: 'bass' },
      { label: 'JIPOS', slug: 'jipos' },
    ],
  },

  // profil shopu na Instagramu: záloha odkazu IG pásu patičky, když nativní
  // widget chybí (siteFooter.js)
  instagram: 'https://www.instagram.com/jiposcz/',

  // Newsletter v patičce jde klasickým POST napřímo do Ecomailu (zadání
  // 2026-09-02, siteFooter.retargetNewsletter): veřejný endpoint seznamu (účet
  // jipos, seznam id 1 „Jipos"). null = nativní formulář Shoptetu beze změny.
  newsletter: {
    ecomailAction: 'https://jipos.ecomailapp.cz/public/subscribe/1',
    // účet Ecomailu a vyskakovací formulář (widget v HTML kódech patičky)
    ecomailAccount: 'jipos',
    popupWidgetId: '7-c01458c4e85a58f0047857fac06ae283',
  },

  // Měření v HTML kódech hlavičky (shoptet-includes/common-header.html přes
  // tools/lib/html-includes.mjs): GTM přes first-party doménu, GA4 = měřicí id
  // nativního gtag Shoptetu (GTM na něj čeká), Microsoft Clarity, Smartsupp
  // (posun tlačítka nad BottomNav). Audit docs/go-live/2026-08-27-audit-html-kodu-a-doplnku.md.
  tracking: {
    gtmId: 'GTM-5WLP6T3',
    gtmOrigin: 'https://nxa.jipos.cz',
    ga4: 'G-P3E0877N45',
    clarity: 'tyap6ikvxx',
    smartsupp: true,
  },

  // Live chat SupportBoxu místo Smartsuppu (účet 19040, chat „Jipos" = 4335;
  // handover 2026-09-28, supportbox-jipos #8). Implementační kód chatu z nastavení
  // Všeobecné. Na ostré ho drží vypnutý přepínač `supportChat` (features.js).
  chat: {
    supportBoxId: 4335,
    supportBoxSecret: '2b8d2c6f98735ce17c0841e6911e3652',
  },

  // CTA zóny SLEVOAKCE na homepage („Zobrazit všech 552…", admin blok #bs-sale)
  promo: {
    saleCount: 552,
  },

  // Kampaně nad kategorií akční nabídky (plán kampaní 2026-10-06, campaign.js).
  // Deštník přejmenuje akční nabídku (`page`) podle data, URL ani admin se
  // nemění. Platí v okně [from, until] času obchodu A se zapnutým přepínačem
  // `feature`; texty v locale/<jazyk>/campaign.js pod klíčem `id`.
  // `claimPct` = „Výprodej skladu až −X %": jen z dat a mění se commitem v den
  // apply ceny (reporting-saas), nikdy datem dopředu. Vlna 1 (6. 10., plán
  // `config/vyprodej-vlny/jipos_cz-2026-10-vlna1.json`): největší sleva proti
  // ceně před výprodejem 30,3 %. Přeškrtnutá běžná cena ukazuje u zboží, které
  // už bylo v akci, až −42 %, ale claim se drží ceny před výprodejem (Omnibus).
  // `tile` = dlaždice výprodeje v pásu akční nabídky: fotka výprodejového zboží se
  // zásobou na ostré (PM-KPLO-12TP, 10 ks k 6. 10.), text kreslí šablona. `photo` =
  // fotka karty mezi produkty cizí kategorie (null = dlaždice `tile` s packshotem).
  // `hero` = text karty 0 hera (médium je karty samotné, karta se nepřesouvá).
  campaigns: [
    {
      id: 'octSale',
      feature: 'campaignOctSale',
      from: '2026-10-06T00:00',
      until: '2026-10-31T23:59:59',
      tone: 'sale',
      page: 'sale',
      claimPct: 30,
      tile: {
        code: 'PM-KPLO-12TP',
        img: 'https://cdn.myshoptet.com/usr/www.jipos.cz/user/shop/big/48418_sada-racnovych-klicu-8-19mm-12ks-pm-kplo-12tp.jpg?ff=1&x=1024&y=768&q=85&ts=69ee34c7&sg=161563f2',
      },
      // vizuál E (2026-10-07, ops/hero/2026-10-vyprodej/): desktop buňka mřížky 2:3,
      // mobil řada přes dva sloupce 16:9; text kreslí šablona
      photo: {
        desktop: 'codex_20261007_vyprodej_e-promo-desktop.jpg',
        mobile: 'codex_20261007_vyprodej_e-promo-mobile.jpg',
      },
      // „−N %" v textu karty musí sedět s `claimPct` (hlídá bs-config.mjs)
      hero: {
        video: 'codex_20261007_vyprodej_e',
        badge: null,
        title: 'Říjnový výprodej',
        desc: 'Výprodej skladu až −30 % a stovky dalších zlevněných produktů do dílny, na zahradu i do domácnosti.',
        cta: 'Zobrazit výprodej',
      },
      media: null,
      xmas: null,
    },
    {
      // Black Friday (vlna B plánu kampaní): týž deštník nad akční nabídkou, černý
      // tón. `claimPct` 30 do apply vlny 2 v reporting-saas (~14. 11., až −50 %),
      // pak commit. `media` = černý vizuál sady BX187 (Codex 19. 10.,
      // ops/hero/2026-11-black-friday/): karta 0 hera, bento a karta Výprodej v mega
      // menu jen v okně (poster karty 0 přednačítá hlavička podmínkou na čas,
      // campaign.js campaignHeroWindows). `xmas` = dlaždice Vánoc ve výprodeji
      // (vlna 2: 12 vánočních SKU), do apply null.
      id: 'blackFriday',
      feature: 'campaignBlackFriday',
      from: '2026-11-01T00:00',
      until: '2026-11-30T23:59:59',
      tone: 'ink',
      page: 'sale',
      claimPct: 30,
      tile: {
        code: 'PM-KPLO-12TP',
        img: 'https://cdn.myshoptet.com/usr/www.jipos.cz/user/shop/big/48418_sada-racnovych-klicu-8-19mm-12ks-pm-kplo-12tp.jpg?ff=1&x=1024&y=768&q=85&ts=69ee34c7&sg=161563f2',
      },
      photo: {
        desktop: 'codex_20261019_bf-promo-desktop.jpg',
        mobile: 'codex_20261019_bf-promo-mobile.jpg',
      },
      hero: {
        video: 'codex_20261007_vyprodej_e',
        badge: null,
        title: 'Black Friday',
        desc: 'Výprodej skladu až −30 % a stovky dalších zlevněných produktů do dílny, na zahradu i do domácnosti.',
        cta: 'Zobrazit Black Friday',
      },
      media: {
        video: 'codex_20261019_bf',
        posterSrc: 'codex_20261019_bf.png',
        bento: 'codex_20261019_bf-bento.webp',
        bentoMobile: 'codex_20261019_bf-bento-m.webp',
        mega: 'codex_20261019_bf-promo-desktop.jpg',
      },
      xmas: null,
    },
  ],

  // Druhý shop téže firmy: přepínač CZ ↔ SK s vlajkami v topbaru, řádek v menu
  // a odkaz v patičce (countrySwitch.js; rozhodnutí Tomáše 2026-10-05, mock
  // a měření ops/sweeps/2026-10-05-prepinac-cz-sk/). Nahrazuje „jen odkaz
  // v patičce" z 27. 8. Důvod tehdejšího rozhodnutí platí dál: druhý shop je
  // samostatný e-shop, ne jazyková mutace, takže přepínač mluví o zemi a shopu.
  // `code` = manifest druhého shopu; build z něj přibalí jen cesty, origin
  // a zemi (src/config/sister.js), ne texty. `label` = řádek v menu a odkaz
  // v patičce, v jazyce TOHOTO shopu.
  sisterShop: {
    code: 'sk',
    label: 'Slovenský e-shop jipos.sk',
  },

  // Kořenové kategorie katalogu pod sémantickým klíčem — moduly k nim vážou
  // ikonu (menuModel.CAT_ICONS), promo kartu a CTA mega menu, kategorie
  // prázdného hledání a dlaždice 404; texty zůstávají v modulech (locale, S3).
  catalog: {
    // Rezerva v pracovních dnech mezi předpokládaným příjmem na sklad (export
    // objednávek u dodavatelů, `/specs` → `restock.expected_at`) a datem, které
    // zákazník vidí „Naskladnění očekáváme do …" (restockDate.js). Sklad je
    // společný pro CZ i SK, pracovní dny = svátky ČR (dispatchEta.js).
    restockBufferDays: 2,
    // Příznak „Výprodej skladu" (admin Příznaky, vlastní 1): vypisuje ho
    // `/vyprodej/`, zapisuje ho reporting-saas spolu s výprodejovou cenou. Karta
    // i detail nesou jediný akční štítek, výprodej má přednost před Slevoakcí
    // (flagOrder.js `oneActionFlag`, plán kampaní 6. 10.).
    clearanceFlag: 'flag-custom1',
    roots: {
      garden: '/zahrada/',
      build: '/stavba--dum/',
      workshop: '/dilna/',
      home: '/domacnost/',
      kids: '/vybaveni-a-hracky-pro-deti/',
      car: '/autodoplnky/',
      xmas: '/vanoce/',
      ppe: '/ochranne-pracovni-pomucky/',
      solar: '/fotovoltaika/',
    },
  },

  // Cesty stránek shopu (systémové slugy platformy i admin slugy info stránek) —
  // jediný zdroj hrefů šablony (modul pages.js) i `INFO_SLUGS` stránkového CSS.
  // null = shop stránku nemá: odkaz na ni se nekreslí. Admin slug může redaktor
  // přejmenovat — pak se mění tady (a snippet hlavičky se přegeneruje).
  pages: {
    cart: '/kosik/',
    checkout: '/objednavka/',
    // děkovací stránka po odeslání objednávky (body `in-dekujeme`)
    checkoutDone: '/objednavka/dekujeme/',
    search: '/vyhledavani/',
    login: '/login/',
    register: '/registrace/',
    account: '/klient/',
    forgotPassword: '/klient/zapomenute-heslo/',
    accountOrders: '/klient/objednavky/',
    accountSettings: '/klient/nastaveni/',
    accountShipping: '/klient/dorucovaci-udaje/',
    accountDiscounts: '/klient/klient-slevy/',
    // doklady, hodnocení a diskuze klientské sekce (sidebar, customerPage.js)
    accountDocs: '/klient/klient-doklady/',
    accountProforma: '/klient/klientske-proforma-faktury/',
    accountCredit: '/klient/klientske-dobropisy/',
    accountDeliveryNotes: '/klient/dodaci-listy-klienta/',
    accountPayments: '/klient/danove-doklady-platba/',
    accountReviews: '/klient/klient-hodnoceni/',
    accountThreads: '/klient/klient-diskuze/',
    brands: '/znacka/',
    // rubriky blogu; `/rubriky/` sám index nemá (404), hlavní rubrika je rady-a-tipy/
    blog: '/rubriky/',
    // kategorie akční nabídky a výprodeje (mega menu, promo pruh, homepage)
    sale: '/slevoakce/',
    clearance: '/vyprodej/',
    contact: '/kontakt/',
    shipping: '/doprava-platba/',
    store: '/prodejna-naradi/',
    b2b: '/b2b/',
    service: '/servis-naradi/',
    // nativní výpis hodnocení obchodu; nese i sekci „Jak recenze ověřujeme"
    // (`reviews.verifyAnchor`, do 7. 10. 2026 samostatná stránka)
    ratings: '/hodnoceni-obchodu/',
    claim: '/reklamacni-formular/',
    claimsPolicy: '/reklamacni-rad/',
    withdrawal: '/odstoupeni-ve-lhute-14-dnu/',
    orderStatus: '/stav-objednavky/',
    faq: '/caste-dotazy/',
    terms: '/obchodni-podminky/',
    privacy: '/podminky-ochrany-osobnich-udaju/',
    // přípona URL produktu pro nativní stránku možností dopravy
    shippingOptions: ':moznosti-dopravy/',
  },
};
